import * as TeamIssueSelector from './team-issue.selectors';
import {SharedIssueBaseSelectors} from "@shared/components/issues/store/shared-issue-base.selectors-type";

const TeamIssueSelectorsMerge = { ...TeamIssueSelector, ...SharedIssueBaseSelectors };
export {TeamIssueSelectorsMerge as TeamIssueSelectors};
